import { render, staticRenderFns } from "./set_pwd_page.vue?vue&type=template&id=371b314d&scoped=true&"
import script from "./set_pwd_page.vue?vue&type=script&lang=js&"
export * from "./set_pwd_page.vue?vue&type=script&lang=js&"
import style0 from "./set_pwd_page.vue?vue&type=style&index=0&id=371b314d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b314d",
  null
  
)

export default component.exports